import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="22" height="22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><circle cx="11" cy="11" r="10.5" fill="#CAFC4F" stroke="#707070" /><path fillRule="evenodd" clipRule="evenodd" d="M15.49 8.273l-3.884 3.884-2.424-2.424-4.243 4.26.643.643 3.6-3.618 2.424 2.425 4.546-4.546v2.558h.909V7.364H12.97v.909h2.52z" fill="#000" /></svg>);